import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const PlusIcon = props => {
  return (
    <Svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M1 6h5m0 0h5M6 6V1m0 5v5"
        stroke="#3876AA"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default PlusIcon;
